import React from 'react';
import HelpContainer from '@/widgets/HelpContainer/HelpContainer';

const WIthHelpContainer = (WrappedComponent: any) => {
    return (props: React.JSX.IntrinsicAttributes) => {
        return (
            <HelpContainer {...props}>
                <WrappedComponent {...props} />
            </HelpContainer>
        );
    };
};

export default WIthHelpContainer;
